import React, { useState, useEffect } from "react";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import { useParams, Link, useNavigate } from "react-router-dom";

import {
  Grid,
  Checkbox,
  Button,
  Typography,
  IconButton,
  
  TextField,
  makeStyles,
} from "@material-ui/core";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import update from "immutability-helper";
import { UPDATE_TERM_APPLICANT_FEEDBACK_MUTATE } from "../../graphQL/term_applicant_qry";


const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },

  textFieldStyle: {
    marginBottom: 5,
    marginTop: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },

  textFieldInput: {
    resize: "both",
    height: "200px",
    maxHeight: "270px",
    width: "500px",
    maxWidth: "550px",
  },
}));

const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

export default function EditApplicantFeedbackDialog({ 
  selectedTermApplicant,   
  closeDialog,  

}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const [feedback, setFeedback] = useState(selectedTermApplicant.feedback);  
  const [lastUpdate, setLastUpdate] = useState("");
  const [flagData, setFlagData] = useState(["Acceptable","Possible","Review"])
  const [selectedFlag, setSelectedFlag] = useState(
  selectedTermApplicant?.feedbackOverall || "Acceptable"
);

  const PopperMy = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };
  
  
  const navigate = useNavigate(); 

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat = format!== null 
                      ? 
                        formatter1.formatToParts(dayDate)
                      :
                        formatter2.formatToParts(dayDate)
                      ;    
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD"){
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  const setValues = async () => {
    let lastUpdate = ""
    if(selectedTermApplicant.feedbackDate)
        lastUpdate = dayFormat(selectedTermApplicant.feedbackDate, "monthDDYYYY") + " - " + selectedTermApplicant.feedbackBy;
    setLastUpdate(lastUpdate);    
  }
  
  useEffect(() => {
    (() => setValues())();
  }, []);

 

  const [updateTermApplicantFeedback] = useMutation(UPDATE_TERM_APPLICANT_FEEDBACK_MUTATE);
  
  const handleSave = async () => {

   const { loading, data, error } = await updateTermApplicantFeedback({
      variables: {
        termApplicantId: parseInt(selectedTermApplicant.termApplicantId),
        feedback: feedback,
        feedbackOverall: selectedFlag,
      },
    });
    if (error) {
      alert("Unfortunately an error occurred.");
    } else if (data && data.updateTermApplicantFeedback) {
      handleClose();
    }
    
    handleClose();    
    
  };

const getColor = (value) => {
  switch (value) {
    case "Acceptable":
      return "#4caf50";
    case "Possible":
      return "#ff9800";
    case "Review":
      return "#f44336";
    default:
      return "#9e9e9e";
  }
};
  

  return (
    <div style={{ width: "100%", minWidth: 600}}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "83%",
              maxWidth: "600px",
              maxHeight: "650px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={11}
              style={{
                textAlign: "center",
                paddingLeft: 15,
              }}
            >
              Staff Feedback
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">

            <Box pt={2} style={{display: "flex",flexDirection: "row",alignItems: "center",}}>
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Applicant Name:
              </Typography>
              {selectedTermApplicant && (
              <Typography variant="h3">
                {selectedTermApplicant.applicantId.userId.firstName}  {selectedTermApplicant.applicantId.userId.lastName}
              </Typography>)}
            </Box>

            <Box pt={2} style={{display: "flex",flexDirection: "row",alignItems: "center",}}>
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Last Updated:
              </Typography>              
              <Typography variant="h3">
                {lastUpdate}
              </Typography>
            </Box>

            <Box pt={2} style={{display: "flex",flexDirection: "row",alignItems: "center",}}>
               

              <FormControl variant="outlined" style={{ minWidth: 150 }}>
              <InputLabel>Overall Feedback</InputLabel>
              <Select
                value={selectedFlag || "Acceptable"}
                onChange={(e) => setSelectedFlag(e.target.value)}
                label="Overall Feedback"
                renderValue={(selected) => (
                  <Box display="flex" alignItems="center">
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: getColor(selected),
                        marginRight: 1,
                      }}
                    />
                    {selected}
                  </Box>
                )}
              >
                {flagData.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Box display="flex" alignItems="center">
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: getColor(option),
                          marginRight: 1,
                        }}
                      />
                      {option}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>             
              
            </Box>

         
            <Box pt={2} style={{display: "flex",flexDirection: "row",alignItems: "center",}}>
              
              <TextField
                id="applicantFeedback"
                variant="outlined"
                multiline
                
                autoFocus
                required
                label="Feedback"
                margin="normal"
                name="applicantFeedback"
                rows={3}
                className={classes.textFieldStyle}
                defaultValue={feedback}
                InputProps={{
                  classes: {
                    input: classes.textFieldInput,
                  },
                }}
                onChange={(e) => setFeedback(e.target.value)}
              />

            </Box>


          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", marginTop: 5 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}

